import { showFailureToast } from "@helpers";
import { reviewApi } from "@services/api";
import { call, put, select } from "redux-saga/effects";
import { getCourseReviewsActions } from "../slices";

function* getCourseReviewsWorker({ payload }) {
  try {
    yield put(getCourseReviewsActions.pending());
    const response = yield call(reviewApi.getCourseReviews, payload);

    // TODO: handle callback | onSuccess
    const { data: reviews } = response.data;
    const payloadSuccess = {
      reviews: reviews || [],
      pagination: response.pagination,
    };

    yield put(getCourseReviewsActions.success(payloadSuccess));
  } catch (error) {
    yield put(getCourseReviewsActions.failure(error));
    yield call(showFailureToast, "Load reviews were failed!");
    // TODO: handle callback | onFailure
  }
}

function* getMoreCourseReviewsWorker({ payload }) {
  try {
    // yield put(getCourseReviewsActions.getMore());
    const state = yield select();
    const pageNumber = state.review.getCourseReviews.pagination.CurrentPage + 1;
    const response = yield call(reviewApi.getCourseReviews, {
      ...payload,
      pageNumber,
    });
    // TODO: handle callback | onSuccess
    const { data: reviews } = response.data;
    const data = {
      reviews: reviews || [],
      pagination: response.pagination,
    };
    yield put(getCourseReviewsActions.getMoreSuccess(data));
  } catch (error) {
    yield put(getCourseReviewsActions.failure(error));
    yield call(showFailureToast, "Load reviews were failed!");
    // TODO: handle callback | onFailure
  }
}

export { getCourseReviewsWorker, getMoreCourseReviewsWorker };
